import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Input, Button } from 'reactstrap';

const LogInputRow = ( props ) => {
  const { exercise, headers } = props;
  const [answer, setAnswer] = useState(exercise.answer);
  const dispatch = useDispatch();

  useEffect(() => {
    setAnswer(exercise.answer)
  }, [exercise]);

  const onChange = (event) => {
    const { name, value } = event.target;

    const changedAnswer = {...answer};
    changedAnswer[name] = {value};

    setAnswer(changedAnswer);
  }

  const onCheck = () => {
    // Compare exercise expected with actual
    const checkedAnswer = {...answer};
    headers.map(header => {
      // checkedAnswer[header.field].className='border border-success';

      if (checkedAnswer[header.field]?.value !== exercise[header.field]) {
        if (checkedAnswer[header.field].value === '') {
          checkedAnswer[header.field] = {value: '', className: 'bg-warning text-white', reason: 'Missing value'}
        }

        if (checkedAnswer[header.field].value !== '' && checkedAnswer[header.field]?.value !== exercise[header.field]) {
          checkedAnswer[header.field] = {value: checkedAnswer[header.field]?.value, className: 'bg-danger text-white', reason: `Value not matching expected: Value: ${checkedAnswer[header.field]?.value}, Expected: ${exercise[header.field]}`}
        }
      }
    })

    setAnswer(checkedAnswer);

    const newExercise = {...exercise, answer: checkedAnswer};
    dispatch({ type: 'SET_WEATHEROBS_EXERCISE_FULFILLED', payload: newExercise });
  };

  const renderRow = () => {
    const columns = headers.map(header => (
      <td className="text-center p-1" field={header.field}>
        <Input
          title={answer[header.field].reason}
          name={header.field}
          type="text"
          bsSize="sm"
          onChange={onChange}
          value={answer[header.field]?.value}
          className={`text-center ${answer[header.field]?.className}`}
        />
      </td>
    ));

    columns.push(<td onClick={() => {onCheck()}} ><Button className="mt-1 text-white" color="success" size="sm">Check</Button></td>);

    return columns;
  }

  return (
    <tr>
      {renderRow()}
    </tr>
  );
}

export default (LogInputRow);
